import 'reflect-metadata';
import { deserealizeTokenWithMetadataAndAmount } from '../Commons/conversions';
import { asEntity } from '../Commons/Decorators/Decorator.asEntity';
import { Convertible } from '../Commons/Decorators/Decorator.Convertible';
import { type TokensWithMetadataAndAmount } from '../Commons/types';
import { SmartUTxOEntity } from './SmartUTxO.Entity';

@asEntity()
export class SmartUTxOWithDetailsEntity extends SmartUTxOEntity {
    protected static _apiRoute: string = 'smartutxos-with-details';
    protected static _className: string = 'SmartUTxO With Details';

    // #region fields

    @Convertible({
        type: Object,
        isArray: true,
        fromPlainObject: deserealizeTokenWithMetadataAndAmount,
    })
    assetsWithDetails!: TokensWithMetadataAndAmount;

    // #endregion fields

    // #region db

    public static alwaysFieldsForCallbackOnAfterLoad: Record<string, boolean> = {
        ...super.alwaysFieldsForCallbackOnAfterLoad,
        assets: true,
    };

    // #endregion db
}
